import _regeneratorRuntime from "/home/fabienjuif/work/k-mille2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/fabienjuif/work/k-mille2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable no-undef */
export var setLocale = function setLocale(_ref) {
  var localesUrl = _ref.localesUrl,
      getState = _ref.getState;
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action, store) {
        var url, locales, raw;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "".concat(localesUrl, "/").concat(getState(store).lang.get(), ".json");
                _context.prev = 1;
                _context.next = 4;
                return (global || window).fetch(url);

              case 4:
                raw = _context.sent;
                _context.next = 7;
                return raw.json();

              case 7:
                locales = _context.sent;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                console.error("/krml i18n/ fail to fetch local at \"".concat(url, "\""), _context.t0.message); // eslint-disable-line no-console

                return _context.abrupt("return");

              case 14:
                getState(store).locale.set(locales);
                window.localStorage.setItem('locale', JSON.stringify(locales));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};
export var getLocale = function getLocale(store) {
  var locale;
  if (store && store.locale.isInitialized()) locale = store.locale.get();

  if (!locale && window.localStorage) {
    var rawLocale = window.localStorage.getItem('locale');

    if (rawLocale) {
      try {
        locale = JSON.parse(rawLocale);
      } catch (e) {
        /* ignore error */
      }
    }
  }

  return locale;
};